import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Helmet } from 'react-helmet-async'

import CustomPaper from '@/components/custom-paper'
import CommunicationList from '@/components/communication/list'
import MunicipalityLoader from '@/wrappers/municipality-loader'
import CommunicationListCollectionCompany from '@/components/communication/list-collection-company'
import MunicipalityPermissionGate from '@/components/municipality-permission-gate'

function CommunicationView({
    collectionCompanyView,
}: {
    collectionCompanyView?: boolean,
}) {

    const title = collectionCompanyView ? 'Reklamace svozů' : 'Komunikace s občany'

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <CustomPaper noPadding>
                <Box p={2.5}>
                    <Typography variant="h2" component="h1">
                        {title}
                    </Typography>
                </Box>
                {collectionCompanyView ?
                    <MunicipalityLoader>
                        {municipality => (
                            <CommunicationListCollectionCompany
                                municipality={municipality}
                            />
                        )}
                    </MunicipalityLoader>
                    :
                    <MunicipalityPermissionGate>
                        <CommunicationList />
                    </MunicipalityPermissionGate>
                }
            </CustomPaper>
        </>
    )
}

export default CommunicationView
